document.addEventListener("DOMContentLoaded", function () {
  const mainImage1 = document.getElementById("duplicate-main-image-1");
  const thumbnails1 = document.querySelectorAll("#image-gallery-duplicate-1 .duplicate-thumbnails img");
  const thumbnailsContainer1 = document.querySelector("#image-gallery-duplicate-1 .duplicate-thumbnails");
  const thumbnailWidth1 = 100; // Width of each thumbnail in pixels
  const visibleThumbnails1 = 5;
  const totalThumbnails1 = thumbnails1.length;
  let currentIndex1 = 0;
  let thumbnailOffset1 = 0;

  // Array of image sources (only English images)
const images1 = [
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3-60ct.jpg?v=1758159288",
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_60ct_PDPs_1x1_English_REV9-25-2-02.jpg?v=1757533795",
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_60ct_PDPs_1x1_English_REV9-25-2-03.jpg?v=1757533795",
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_60ct_PDPs_1x1_English_REV9-25-2-04.jpg?v=1757533790",
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_60ct_PDPs_1x1_English_REV9-25-2-05.jpg?v=1757533783",
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_60ct_PDPs_1x1_English_REV9-25-2-06.jpg?v=1757533790",
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_60ct_PDPs_1x1_English_REV9-25-2-07.jpg?v=1757533795",
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_60ct_PDPs_1x1_English_REV9-25-2-08.jpg?v=1757533795",
  "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_60ct_PDPs_1x1_English_REV9-25-2-09.jpg?v=1757533788"
];


  
  function updateGallery1(index) {
    currentIndex1 = (index + images1.length) % images1.length;
    const previousImage1 = mainImage1;
    previousImage1.classList.add("image-exit");
    
    setTimeout(() => {
      previousImage1.classList.remove("image-exit");
      const tempImage1 = new Image();
      tempImage1.src = images1[currentIndex1];
      tempImage1.onload = () => {
        mainImage1.classList.add("image-enter");
        mainImage1.src = images1[currentIndex1];
        setTimeout(() => {
          mainImage1.classList.add("show");
          mainImage1.classList.remove("image-enter");
        }, 50);
      };
    }, 500);

    thumbnails1.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === currentIndex1);
    });

    adjustThumbnails1();
  }

  function adjustThumbnails1() {
    // Calculate how many thumbnails fit in the container dynamically
    const containerWidth = thumbnailsContainer1.offsetWidth;
    const visibleCount = Math.floor(containerWidth / thumbnailWidth1) || 1; // at least 1
  
    if (currentIndex1 >= visibleCount - 1 && currentIndex1 < totalThumbnails1) {
      thumbnailOffset1 = currentIndex1 - (visibleCount - 2);
      // Clamp the offset to valid values
      if (thumbnailOffset1 < 0) thumbnailOffset1 = 0;
      if (thumbnailOffset1 > totalThumbnails1 - visibleCount) {
        thumbnailOffset1 = totalThumbnails1 - visibleCount;
      }
      thumbnailsContainer1.style.transform = `translateX(-${thumbnailOffset1 * thumbnailWidth1}px)`;
    } else {
      thumbnailsContainer1.style.transform = `translateX(0)`;
    }
  }

  thumbnails1.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      if (index !== currentIndex1) {
        updateGallery1(index);
      }
    });
  });

  let startX1 = 0;
  let isSwiping1 = false;
  
  // Touch events
  mainImage1.addEventListener("touchstart", function(e) {
    startX1 = e.touches[0].clientX;
    isSwiping1 = true;
  });
  
  mainImage1.addEventListener("touchmove", function(e) {
    if (!isSwiping1) return;
    const currentX = e.touches[0].clientX;
    const diff = startX1 - currentX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? updateGallery1(currentIndex1 + 1) : updateGallery1(currentIndex1 - 1);
      isSwiping1 = false;
    }
  });
  
  mainImage1.addEventListener("touchend", () => { isSwiping1 = false; });
  
  // Mouse events for desktop swiping
  mainImage1.addEventListener("mousedown", function(e) {
    startX1 = e.clientX;
    isSwiping1 = true;
  });
  
  mainImage1.addEventListener("mousemove", function(e) {
    if (!isSwiping1) return;
    const currentX = e.clientX;
    const diff = startX1 - currentX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? updateGallery1(currentIndex1 + 1) : updateGallery1(currentIndex1 - 1);
      isSwiping1 = false;
    }
  });
  
  mainImage1.addEventListener("mouseup", () => { isSwiping1 = false; });
  mainImage1.addEventListener("mouseleave", () => { isSwiping1 = false; });
  
  // Initialize gallery
  updateGallery1(currentIndex1);
  window.addEventListener("resize", adjustThumbnails1);
});
